<template>
  <div v-loading="loading" class="team">
    <!-- 成员列表 -->
    <div>
      <div class="title-class base-flex__between">
        <div class="titleCls">{{ $t('team.memberList') }}</div>
        <!-- 邀请成员按钮 -->
        <div>
          <el-button class="btn-invite titleCls" type="text" @click="showInvitationCode()"
            >{{ $t('team.inviteMember') }}
          </el-button>
        </div>
      </div>
      <div class="base-background__white pad_top_bottom_right——20">
        <el-table :data="projectUserListData" align="center" border header-align="center">
          <!-- 成员ID -->
          <el-table-column :label="$t('team.memberId')" prop="user.id" width="100"></el-table-column>
          <!-- 成员名称 -->
          <el-table-column :label="$t('team.memberName')" prop="user.name">
            <template slot-scope="scope">
              {{ scope.row.user.name }}
              <el-tag
                v-if="scope.row.linuxSudoPermission === 1 || !deployModeCluster"
                class="base-margin__left-8"
                type="success"
              >
                SUDO
              </el-tag>
            </template>
          </el-table-column>
          <!-- Linux 用户名称 -->
          <el-table-column :label="$t('team.linuxUserName')">
            <template slot-scope="scope">
              {{ scope.row.linuxName }}
            </template>
          </el-table-column>
          <!-- 角色权限 -->
          <el-table-column :label="$t('team.rolePermission')" prop="roleName"> </el-table-column>
          <!-- Linux UID -->
          <el-table-column :label="$t('team.uid')" width="80">
            <template slot-scope="scope">
              {{ scope.row.linuxUid }}
            </template>
          </el-table-column>
          <!-- Linux GID -->
          <el-table-column :label="$t('team.gid')" width="80">
            <template slot-scope="scope">
              {{ scope.row.linuxGid }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('team.vncPort')" width="100">
            <template slot-scope="scope">
              {{ scope.row.vncPort }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('team.memberEmail')" prop="user.email"></el-table-column>
          <!-- 加入日期 -->
          <el-table-column :label="$t('team.joinDate')" prop="createTime"> </el-table-column>
          <!--<el-table-column :label="$t('team.cfsQuota')" prop="createTime"></el-table-column>-->
          <!-- 操作 -->
          <el-table-column v-if="isOwner" :label="$t('team.operation')" prop="address" width="400">
            <template slot-scope="scope">
              <div class="base-flex__cross-center base-flex__center">
                <div>
                  <span v-if="scope.row.roleName !== $t('team.admin')" class="base-margin__right-10">
                    <el-button type="text" @click="deleteProjectUser(scope.row)">
                      {{ $t('team.disable') }}
                    </el-button>
                    <el-button type="text" @click="transferAdminAuth(scope.row)">
                      {{ $t('team.transferAdmin') }}
                    </el-button>
                  </span>
                </div>
                <el-dropdown>
                  <span class="el-dropdown-link base-cursor__pointer base-color__light_blue">
                    {{ $t('team.computeCluster') }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="scope.row.linuxSudoPermission === 0">
                      <el-button :disabled="!deployModeCluster" type="text" @click="addUserSudoPermission(scope.row)"
                        >{{ $t('team.enableSudo') }}
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item v-else>
                      <el-button :disabled="!deployModeCluster" type="text" @click="deleteUserSudoPermission(scope.row)"
                        >{{ $t('team.disableSudo') }}
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="loginType === 'qq'">
                      <el-button type="text" @click="getClusterAuthCode(scope.row)"
                        >{{ $t('team.oecliAuthCode') }}
                      </el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 邀请成员 -->
    <div :class="loginType === 'cloud' && isOwner === 1 ? '' : 'no-dialog-header'">
      <el-dialog
        :close-on-click-modal="false"
        :title="
          loginType === 'cloud' && isOwner === 1
            ? `${$t('team.inviteTencentCloudUser')} (${$t('team.invitationCode')} ${invitationCode})`
            : ''
        "
        :visible.sync="dialogVisible"
        top="15vh"
        width="600px"
        @close="getProjectApproveList"
      >
        <div>
          <div v-if="loginType === 'cloud' && isOwner === 1">
            <el-table
              v-loading="addTeamLoading"
              :data="tableData"
              header-align="center"
              class="base-width_fullscreen"
              max-height="600"
            >
              <el-table-column :label="$t('team.name')" prop="Name"> </el-table-column>
              <el-table-column label="uin" prop="Uin"> </el-table-column>
              <!--<el-table-column-->
              <!--  :label="$t('team.createTime')"-->
              <!--  prop="CreateTime">-->
              <!--</el-table-column>-->
              <el-table-column :label="$t('team.operation')">
                <template slot-scope="scope">
                  <el-button
                    :disabled="scope.row.disabledIds"
                    type="text"
                    @click.native.prevent="addTeam(scope.row, scope.$index)"
                  >
                    {{ $t('team.invite') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else class="copy-area">
            <span class="depoly-dialog__invita-span">{{ $t('team.exclusiveInvitationCode') }}</span>
            <br />
            <span class="invitationCode">{{ invitationCode }}</span>
            <p>
              {{ userInfo.nickName }} {{ $t('team.invitationDescription') }} [
              <span class="base-color__lightGreen">{{ projectName }}</span> ]
            </p>
            <el-button type="primary" @click="copyInviteClick(invitationCode)"
              >{{ $t('team.copyInvitation') }}
            </el-button>
          </div>
        </div>
      </el-dialog>

      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="oecliDialogVisible"
        class="no-dialog-header"
        top="15vh"
        width="600px"
      >
        <div>
          <div class="copy-area">
            <span class="depoly-dialog__invita-span">{{ $t('team.oecliAuthCode') }}</span>
            <br />
            <span class="oecliCode">{{ oecliCode }}</span>
            <div class="base-text-align__center base-margin__top-10">
              <!--              {{ userInfo.nickName }} {{ $t('team.invitationDescription') }} [ <span class="base-color__lightGreen">{{-->
              <!--                projectName-->
              <!--              }}</span> ]-->
              {{ $t('team.authCodeExpire') }}
            </div>
            <el-button size="small" type="primary" @click="copyInviteClick(oecliCode)"
              >{{ $t('team.copyAuthCode') }}
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { postRequest } from '@/common/libs/request';
import { APPLY_ACCEPT } from '@/common/constants';
import { copyText } from '@/common/utils/utils';
import { Message } from 'element-ui';

export default {
  name: 'IndexView',
  data() {
    return {
      loading: false, // 团队管理页面loading状态
      tableApplayData: [], // 审批列表数据
      projectUserListData: [], // 项目成员列表数据
      projectId: 0, // 项目id
      invitationCode: '', // 邀请码
      isOwner: 0, // 是否为管理员
      projectName: '', // 项目名称
      applyAccept: APPLY_ACCEPT, // 申请接受
      dialogVisible: false, // 邀请成员dialog
      loginType: window.sessionStorage.getItem('loginType'),
      isAdmin: window.sessionStorage.getItem('isAdmin'),
      tableData: [],
      projectUserList: [],
      addTeamLoading: false,
      oecliDialogVisible: false,
      oecliCode: '',
      deployModeCluster: false,
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
    userInfo() {
      return this.app.userInfo;
    },
  },
  filters: {
    /**
     * 成员角色过滤器
     * @param val 成员角色
     */
    roleFilter(val) {
      switch (val) {
        case 'owner':
          return this.$t('team.admin');
        case 'member':
          return this.$t('team.teamMember');
        default:
          return this.$t('team.applyToJoin');
      }
    },
  },
  watch: {
    currentProject() {
      this.getProjectApproveList();
    },

    /**
     * 监听项目信息变化
     * @param val 变化后的项目信息
     */
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      this.isOwner = val.isOwner;
      if (currentProject.id !== this.projectId) {
        this.projectId = val.id;
        this.projectName = val.name;
        this.invitationCode = currentProject.invitationCode;
        this.getProjectApproveList();
      }
    },
  },
  methods: {
    getClusterAuthCode(val) {
      const params = {
        userId: val.user.id,
        duration: 30,
        operation: 'cluster:*',
      };
      postRequest('/api/eda/common/project/getClusterAuthCode', params).then((res) => {
        this.oecliCode = res.authKey;
        this.oecliDialogVisible = true;
      });
    },
    /**
     * 开启成员Linux SUDO 权限
     */
    addUserSudoPermission(val) {
      this.loading = true;
      postRequest('/api/eda/common/project/addUserSudoPermission', { userId: val.user.id })
        .then(() => {
          this.loading = false;
          Message.success(this.$t('team.enableSudoSuccess'));
          this.getProjectApproveList();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /**
     * 关闭成员Linux SUDO 权限
     */
    deleteUserSudoPermission(val) {
      this.loading = true;
      postRequest('/api/eda/common/project/deleteUserSudoPermission', { userId: val.user.id })
        .then(() => {
          this.loading = false;
          Message.success(this.$t('team.disableSudoSuccess'));
          this.getProjectApproveList();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 审批
     * @description:
     * @param {*} action 审批操作（通过、驳回）
     * @param {*} idx 数据索引
     * @param {*} row 审批数据
     * @return {*}
     */
    async onApprove(action, idx, row) {
      this.loading = true;
      try {
        if (action !== 'pass' && action !== 'reject') {
          this.$message(this.$t('team.approveParamError'));
          return false;
        }

        const res = await postRequest('/api/eda/common/project/projectApplyApprove', {
          applyId: row.id,
          action,
          projectId: row.projectId,
        });

        if (res) {
          this.$message.success(this.$t('team.approveSuccess'));
          // this.tableApplayData[idx].status = action === 'reject' ? 2 : 3;
          this.getProjectApproveList();
        }
      } catch (e) {
        this.$message(this.$t('team.approveFailed'));
      }
      this.loading = false;
    },

    /**
     * 禁用用户
     */
    deleteProjectUser(data) {
      this.loading = true;
      postRequest('/api/eda/common/project/deleteProjectUser', {
        userId: data.user.id,
      })
        .then(() => {
          this.loading = false;
          Message.success(this.$t('team.disableUserSuccess'));
          this.getProjectApproveList();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 复制邀请码
     */
    copyInviteClick(val) {
      copyText(this, val);
    },
    /**
     * 展示邀请码
     */
    showInvitationCode() {
      if (this.loginType === 'cloud') {
        postRequest('/api/eda/common/eda/getCloudUserList', {}).then((res) => {
          this.tableData = res?.list || [];
          this.tableData.some((item) => {
            if (this.projectUserList.includes(item.name)) {
              item.disabledIds = true;
            } else {
              item.disabledIds = false;
            }
          });
        });
      }
      this.dialogVisible = true;
    },
    /**
     * 加入团队
     */
    addTeam(row, index) {
      this.addTeamLoading = true;
      postRequest('/api/eda/common/project/addCloudUserToProject', { uin: row.Uin.toString() })
        .then(() => {
          const data = JSON.parse(JSON.stringify(this.tableData));
          data[index].disabledIds = true;
          this.tableData = data;
          this.addTeamLoading = false;
          this.$message.success(this.$t('team.inviteUserSuccess'));
        })
        .catch(() => {
          this.addTeamLoading = false;
        });
    },

    /**
     * 移交管理员权限
     */
    transferAdminAuth(item) {
      this.$confirm(this.$t('team.transferAdminConfirm'), this.$t('team.transferAdmin'), {
        confirmButtonText: this.$t('team.confirm'),
        cancelButtonText: this.$t('team.cancel'),
        type: 'warning',
      }).then(() => {
        this.loading = true;
        postRequest('/api/eda/common/project/transferAdminAuth', {
          userId: +item.user.id,
        })
          .then(() => {
            this.loading = false;
            Message.success(this.$t('team.transferAdminSuccess'));
            this.isOwner = 0;
            this.getProjectApproveList();
            this.$store.dispatch('app/getProjectList');
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },

    /**
     * 获取审批和成员列表
     * @description:
     * @return {*}
     */
    async getProjectApproveList() {
      // 成员列表
      try {
        const res = await postRequest('/api/eda/common/project/getProjectUserList');
        if (res) {
          res.list.map((item, index) => {
            if (index === 0) {
              item.roleName = this.$t('team.admin');
            } else {
              item.roleName = this.$t('team.normalUser');
            }
          });
          const list = res.list.map((item) => item.user.name);
          this.projectUserList = list;
          this.projectUserListData = res.list || [];
          this.deployModeCluster = res.deployMode === 'cluster';
        }
      } catch (e) {
        this.$message(this.$t('team.getMemberListFailed'));
      }
    },
  },
  mounted() {
    const currentProject = this.getCurrentProject() || {};
    this.isOwner = currentProject.isOwner;
    this.projectId = currentProject.id;
    this.invitationCode = currentProject.invitationCode;
    this.projectName = currentProject.name;
    this.getProjectApproveList();
  },
};
</script>

<style lang="scss" scoped>
// 团队管理整体样式
.team {
  text-align: left;
  //background: #eee;

  // 邀请按钮
  .btn-invite {
    padding-top: 10px;
    padding-right: 10px;
  }

  .title-class {
    padding: 10px;
    background: #fff;
  }
}

.titleCls {
  font-size: 14px;
  font-weight: 600;
  margin-left: 10px;
  padding-top: 10px;
}

.no-dialog-header {
  &:deep(.el-dialog__header) {
    border: none;
  }

  &:deep(.el-dialog__body) {
    background-image: url('./image/invite-dialog.png');
    background-size: cover;
    padding: 30px 40px 15px;
  }

  &:deep(.el-dialog__header) {
    padding: 0;
  }
}

.el-table {
  &:deep(.el-table__cell) {
    text-align: center;
  }
}

.pad_bot_cls {
  padding-bottom: 10px;
}

.pad_top_bottom_right——20 {
  padding: 0 20px 20px;
}

.copy-area {
  margin-bottom: 24px;
  font-size: 14px;
  line-height: 24px;
  text-align: center;

  .depoly-dialog__invita-span {
    color: #23253a;
    font-size: 20px;
    display: block;
    margin-bottom: 20px;
  }

  p {
    margin-top: 16px;
    text-align: left;
    color: #666666;
  }

  //
  //button {
  //  margin-top: 15px;
  //  padding: 0;
  //  width: 90px;
  //  min-height: 30px;
  //  text-align: center;
  //}
}

.invitationCode {
  color: #006eff;
  font-size: 48px;
}

.oecliCode {
  color: #006eff;
  font-size: 30px;
  padding: 10px 0;
}
</style>
